<template>
  <div>
   <Header1></Header1>
   <router-view></router-view>
   <Footer></Footer>
   </div>
</template>

<script>

import Header1 from './components/Header.vue'
import Footer from './components/Footer.vue'
export default {
  name: 'App',
  components: {
    Header1,
    Footer
  },
  created(){
    let _userTmp = sessionStorage.getItem('_fruitUser')
    if(_userTmp){
      try{
        let _user = JSON.parse(_userTmp)
        this.$store.commit('setUser',_user)
      }catch(e){
        console.log('error',e)
        
        //TODO handle the exception
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue